import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import AuthShell from '../components/auth/AuthShell'
import MaterialIcon from '../components/ui/MaterialIcon'
import { KILO } from '../constants/KILO_THEME'
import { useUserLanguage } from '../hooks/useUserLanguage'

const VerifyEmail = () => {
  const { t } = useTranslation()
  useUserLanguage()
  const location = useLocation()
  const navigate = useNavigate()
  const email = (location.state as { email?: string })?.email ?? ''

  return (
    <AuthShell
      title={t('auth.confirmAccount')}
      subtitle={t('auth.confirmSubtitle')}
      icon="mark_email_unread"
    >
      <div className="flex flex-col items-center gap-5 text-center">
        <div className="flex h-20 w-20 items-center justify-center rounded-2xl border border-kilo-border bg-kilo-nested">
          <MaterialIcon name="outgoing_mail" filled size="xl" />
        </div>

        <p className={`text-sm leading-relaxed ${KILO.text.muted}`}>
          {t('auth.verificationSent')}{' '}
          <span className={`font-semibold ${KILO.text.primary}`}>{email || t('auth.yourEmail')}</span>. {t('auth.verificationInstructions')}
        </p>

        <button
          type="button"
          onClick={() => navigate('/')}
          className="flex h-12 w-full items-center justify-center gap-2 rounded-2xl bg-kilo-accent text-base font-bold text-black transition hover:bg-kilo-accent-dark"
        >
          <MaterialIcon name="arrow_back" size="sm" />
          {t('auth.returnToSignIn')}
        </button>
      </div>
    </AuthShell>
  )
}

export default VerifyEmail
